import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { useI18n } from '../../../../context/occ/hooks/use-i18n';
import { Heading } from '../../../../subcomponents/heading/heading';
const b = bemClassBuilder('v-member-name');
/**
 * Renders a Loyalty member's name.
 */
export const MemberNameUI = props => {
    const i18n = useI18n();
    const { name, config, className } = props;
    return (_jsx(Heading, Object.assign({ level: config.headingLevel, className: b.block(undefined, className) }, { children: i18n.personName(name) })));
};
MemberNameUI.displayName = 'MemberNameUI';
